import banner1 from "@/../../src/_asset/banner/zeusbanner1.png"
import koreanair_banner1 from "@/../../src/_asset/banner/koreanair_banner1.mp4"

export default function MainBanner() {
    return (
        <div className={"main-intro"}>
            <img src={banner1} alt="" />
            {/* <video src={koreanair_banner1} muted loop autoPlay playsInline></video> */}
        </div>
    )
}